import { Component, EventEmitter, OnInit, Output } from '@angular/core';


interface DownloadStudyData {
  patientName: string;
  patientId: string;
  accessionNumber: string;
  anonymize: boolean;
}

interface DownloadDICOMEvent {
  relationsId: Set<number>;
  downloadButton: HTMLElement; 
  studyData?: DownloadStudyData;
  downloadSameZip: boolean;
}

interface DownloadGraphicEvent {
  relationsId: Set<number>;
  pdf: boolean;
}

enum DownloadType {
  DICOM = 'DICOM',
  PDF = 'PDF',
  JPG = 'JPG'
}

enum ModalView {
  FORMAT_SELECTION = 'FORMAT_SELECTION',
  DICOM_CONFIG = 'DICOM_CONFIG'
}

@Component({
  selector: 'app-download-study-modal',
  templateUrl: './download-study-modal.component.html',
  styleUrls: ['./download-study-modal.component.css']
})
export class DownloadStudyModalComponent implements OnInit{

  ModalView = ModalView;

  @Output() download = new EventEmitter<{
    type: DownloadType;
    relationsId: Set<number>;
    downloadButton: any;
    studyData?: DownloadStudyData;
    downloadSameZip?: boolean;
  }>();

  currentView: ModalView = ModalView.FORMAT_SELECTION;


  opened = false;

  private relationsId: Set<number> = new Set();  
  downloadButton: any;


  // Datos del estudio para el formulario
  patientName: string = '';
  patientId: string = '';
  accessionNumber: string = '';
  anonymize: boolean = false;

  // Variable de descarga en bloque
  downloadSameZip: boolean = false;

  
  constructor() { }

  ngOnInit(): void {
  }

  open(relationsId: Set<number>, downloadButton: any) {
    this.relationsId = new Set(relationsId);
    this.downloadButton = downloadButton;
    this.opened = true;
  }

  close() {
    this.opened = false;
  }

  private isFormValid(): boolean {
    if (this.relationsId.size !== 1) return true;
    
    const hasRequiredFields = this.patientName?.trim() && 
                            this.patientId?.trim() && 
                            this.accessionNumber?.trim();
    
    return !!hasRequiredFields;
  }

  downloadDCMS() {
    if (!this.isFormValid()) {
      //this.alertService.alert('No se puede continuar sin completar todos los campos obligatorios');
      return;
    }
    
    const studyData = this.relationsId.size === 1 ? {
      patientName: this.patientName.trim(),
      patientId: this.patientId.trim(),
      accessionNumber: this.accessionNumber.trim(),
      anonymize: this.anonymize
    } : undefined;

    this.download.emit({
      type: DownloadType.DICOM,
      relationsId: this.relationsId, 
      downloadButton: this.downloadButton,
      studyData,
      downloadSameZip: this.downloadSameZip
    });
    
    this.clearVariables();
    this.close();
  }

  downloadJPGS(){

    this.download.emit({
      type: DownloadType.JPG,
      relationsId: this.relationsId, 
      downloadButton: this.downloadButton,
      downloadSameZip: this.downloadSameZip
    });

    this.clearVariables();
    this.close();
  }

  downloadPDF(){

    this.download.emit({
      type: DownloadType.PDF,
      relationsId: this.relationsId, 
      downloadButton: this.downloadButton,
      downloadSameZip: this.downloadSameZip
    });

    this.clearVariables();
    this.close();
  }

  clearVariables() {
    this.relationsId = new Set();
    this.downloadButton = null;
    this.patientName = '';
    this.patientId = '';
    this.accessionNumber = '';
    this.anonymize = false;
    this.downloadSameZip = false;
    this.currentView = ModalView.FORMAT_SELECTION;
  }

  async checkDownload() {
    if (this.relationsId.size === 1) {
      try {
        this.currentView = ModalView.DICOM_CONFIG;
        await this.obtainStudyData();
      } catch (error) {
        console.error('Error preparando descarga:', error);
        this.currentView = ModalView.FORMAT_SELECTION;
      }
    } else {
      this.downloadDCMS();
    }
  }

  closeSecondDownloadModal() {
    this.currentView = ModalView.FORMAT_SELECTION;
  }

  obtainStudyData(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.relationsId.size !== 1) {
        reject(new Error('Se requiere exactamente un estudio'));
        return;
      }

      const relId = Array.from(this.relationsId)[0];
      
      /*this.relationsService.getStudyPACSByRelId(relId).subscribe({
        next: (study) => {
          this.patientName = study.patientDto.name; 
          this.patientId = study.patientDto.patientId; 
          this.accessionNumber = study.accessionNumber || ''; 
          console.log('Datos cargados para relId:', relId);
          resolve();
        },
        error: (error) => {
          console.error('Error obteniendo datos del estudio:', error);
          //this.alertService.alert('Error al cargar datos del estudio');
          reject(error);
        }
      });*/
    });
  }

}
